
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import global from '../../static/js/global.js'
export default {
data(){
return{
mobile:'',
verify:'',
code:'',
messageWarn:'',
message:'获取验证码',
isShow:false,
isdisable:false,
isjump:false,
readonly:false
}
},
components: {
XHeader,
XInput,
Group,
XButton
},
methods:{
beforXy(mrquerUrl){

let objectInfo = new Object();
objectInfo.comnCode = "";
objectInfo.hsNo =  "";
objectInfo.hsName =  "";
objectInfo.phone = this.mobile;
objectInfo.phoneModel = navigator.userAgent;
objectInfo.requestUrl = mrquerUrl;

console.log("&&&&&&&&&&&&&&&")
console.log(objectInfo)
let newUrl = global.host + 'sys/addSystemLog';
this.$http.post(newUrl,objectInfo).then(function(res){
console.log(res.body.result)
},function(err){
console.log(err)
})
},
getSms(){
if(!this.mobile){
this.messageWarn = '请输入您输入的手机号'
}else if(!this.$refs.mobile.valid){
this.messageWarn = '您输入的手机号有误'
}else{
this.messageWarn = ''
this.readonly = true
this.beforXy("#发送验证码检测#message/pushMessage?phone="+ this.mobile);
this.$http.get(global.host + 'message/pushMessage?phone=' + this.mobile).then(function(res){
this.code = res.body.result.code;
console.log(res)
},function(err){
console.log(err)
})
this.changeState();
}
},
changeState(){
let time = 60;
this.isdisable = true;
this.isShow = true;
let self = this;
self.message = time + 's'
let hander = window.setInterval(function(){
if(time == 0){
self.isdisable = false;
self.isShow = false;
self.message = '重新获取';
this.readonly = false;
window.clearInterval(hander);
}else{
time--
self.message = time + 's'
}
},1000);
},
redirection(){
if(!this.mobile){
this.messageWarn ='请输入手机号码'
}else if(!this.verify){
this.messageWarn ='请输入验证码'
}else if(this.verify != this.code){
this.messageWarn ='验证码有误'
}else{
this.isjump = false;
this.beforXy("#进入下一步验证#users/register_first/"+ this.$router.history.current.query.openid +'/' + this.mobile + "/" + this.$router.history.current.query.nickname + '?url=' + this.$router.history.current.query.headerimgurl);
this.$http.post(global.host + 'users/register_first/'+ this.$router.history.current.query.openid +'/' + this.mobile + "/" + this.$router.history.current.query.nickname + '?url=' + this.$router.history.current.query.headerimgurl).then(function(res){
console.log(res)
if(res.body.success){
this.$router.push({path:'/houseBind',query:{openid:this.$router.history.current.query.openid,phone:this.mobile,IsDefault:1}})
}else{
this.messageWarn ='服务异常，请稍后！'
}
},function(err){
console.log(err)
});
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/register.vue